import styled from 'styled-components';

import {
  Modal,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Dialog = styled(Modal)`
  &&& {
    padding: 20px 30px 30px;
    width: 480px;
  }
`;

const Content = styled(Modal.Content)``;

const Title = styled(TextLayoutComponent.Title)`
  text-align: left;
  padding-bottom: 25px;
  font-weight: 500;
  word-break: break-all;
`;

const Text = styled(TextLayoutComponent)`
  font-size: 18px;
  color: ${({ theme }) => theme.color.textTitle};
  margin-right: 12px;
  margin-bottom: 10px;
`;

const Button = styled(ButtonLayoutComponent)`
  width: 80px;
`;

const ButtonInverted = styled(ButtonLayoutComponent.Inverted)`
  width: 80px;
`;

const ContainerDropdown = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 25px;
  width: 220px;
  `;

const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 25px;
  padding-top: 25px;
`;

const WarningMessage = styled.div`
  background: ${({ theme }) => theme.color.backgroundMessage};
  font-size: ${({ theme }) => theme.fontSize.textMuted};
  padding: 10px;
  margin-top: 10px;
`;

const ContainerFolder = styled.div``;

export {
  Button,
  ButtonInverted,
  ContainerButton,
  ContainerDropdown,
  Content,
  Dialog,
  WarningMessage,
  Text,
  Title,
  ContainerFolder,
};
